<template>
  <nav
    class="shadow-none navbar navbar-main navbar-expand-lg border-radius-xl"
    v-bind="$attrs"
    id="navbarBlur"
    data-scroll="true"
  >
    <div class="px-3 py-1 container-fluid">
      <breadcrumbs :breadcrumbs="breadcrumbs" :textWhite="textWhite" />
      <div class="mt-2 collapse navbar-collapse mt-sm-0 me-md-0 me-sm-4" :class="this.$store.state.isRTL ? 'px-0' : 'me-sm-4'" id="navbar">
        <div class="pe-md-3 d-flex align-items-center" :class="this.$store.state.isRTL ? 'me-md-auto' : 'ms-md-auto'">
          <!-- <div class="input-group">
            <span class="input-group-text text-body">
              <i class="fas fa-search" aria-hidden="true"></i>
            </span>
            <input type="text" class="form-control" :placeholder="this.$store.state.isRTL ? 'أكتب هنا...' : 'Type here...'"/>
          </div> -->
        </div>
        <ul class="navbar-nav justify-content-end">
          <li class="nav-item d-flex align-items-center mx-3">
              <span class="d-sm-inline d-none">{{ role }}</span>
          </li>
          <li class="nav-item d-flex align-items-center mx-3">
            <router-link :to="{ name: this.$store.getters.horseListMenuLink }" class="px-0 nav-link font-weight-bold" :class="textWhite ? textWhite : 'text-body'">
              <i class="fa fa-user" :class="this.$store.state.isRTL ? 'ms-sm-2' : 'me-sm-1'"></i>
              <span v-if="this.$store.state.isRTL" class="d-sm-inline d-none">يسجل دخول</span>
              <span v-else class="d-sm-inline d-none">Profilo </span>
            </router-link>
          </li>
          <li class="nav-item d-flex align-items-center">
            <router-link :to="{ name: 'Sign In' }" class="px-0 nav-link font-weight-bold" :class="textWhite ? textWhite : 'text-body'">
              <i class="fa fa-sign-out" :class="this.$store.state.isRTL ? 'ms-sm-2' : 'me-sm-1'"></i>
              <span v-if="this.$store.state.isRTL" class="d-sm-inline d-none">يسجل دخول</span>
              <span v-else @click="logout" class="d-sm-inline d-none">{{ this.$store.getters.isAuthenticated ? 'Log out' : 'Sign In' }} </span>
            </router-link>
          </li>
          <li class="nav-item d-xl-none ps-3 d-flex align-items-center">
            <a href="#" @click="toggleSidebar" class="p-0 nav-link text-body" id="iconNavbarSidenav">
              <div class="sidenav-toggler-inner">
                <i class="sidenav-toggler-line"></i>
                <i class="sidenav-toggler-line"></i>
                <i class="sidenav-toggler-line"></i>
              </div>
            </a>
          </li>
          <li class="px-3 nav-item dropdown d-flex align-items-center" :class="this.$store.state.isRTL ? 'ps-2' : 'pe-2'">
            <a href="#" class="p-0 nav-link notif-section" :class="[
                textWhite ? textWhite : 'text-body',
                showMenu ? 'show' : '',
              ]" id="dropdownMenuButton" data-bs-toggle="dropdown" aria-expanded="false" @click="showMenu = !showMenu">
              <i class="cursor-pointer fa fa-bell"></i> <div class="notif-badge" v-if="this.$store.state.unread_count > 0">{{ this.$store.state.unread_count  }}</div>
            </a>
            <ul class="px-2 py-3 dropdown-menu dropdown-menu-end me-sm-n4" :class="showMenu ? 'show' : ''" aria-labelledby="dropdownMenuButton">
              <li class="mb-2" v-for="(notif, index) in this.$store.state.notifications" :key="index">
                <div class="dropdown-item border-radius-md">
                  <div class="py-1 d-flex">
                    <div class="my-auto" style="margin-right: 15px;font-size: 2em;">
                      <font-awesome-icon :icon="notif.is_read ? faEnvelopeOpen : faEnvelope" color="cadetblue" />
                    </div>
                    <div class="d-flex flex-column justify-content-center">
                      <h6 class="mb-1 text-sm font-weight-normal">
                        {{ notif.name }} <RouterLink v-if="notif.horse_id" style="margin: 5px; text-decoration: underline;" @click="markRead(notif)" :to="{ name: 'Horse', params: { action: 'view', id: notif.horse_id } }">mostra cavallo</RouterLink>
                      </h6>
                      <p class="mb-0 text-xs text-secondary">
                        <i class="fa fa-clock me-1"></i>
                        {{ this.formatDate(notif.created) }} &nbsp;&nbsp;&nbsp;&nbsp; <a href="#" v-if="!notif.is_read" @click="markRead(notif)" :class="{ loading: loading }">Segna come letto</a>
                      </p>
                    </div>
                  </div>
                </div>
              </li>
              <li v-if="this.$store.state.notifications.length == 0" style="text-align: center">
                <div class="dropdown-item border-radius-md"><div class="py-1 d-flex">-- Nessuna Notifica --</div></div>
              </li>
              <li>
                <div style="text-align: center">
                  <RouterLink style="margin: 5px; text-decoration: underline;" :to="{ name: 'Notifications', params: {} }">Visualizza tutte le notifiche</RouterLink>
                </div>
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</template>
<script>
import Breadcrumbs from "../Breadcrumbs.vue";
import { mapMutations, mapActions, mapGetters } from "vuex";
import {axiosService} from "@/services/AxiosService";
import {userService} from "@/services/UsersService";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { faEnvelope, faEnvelopeOpen } from "@fortawesome/free-solid-svg-icons";

export default {
  name: "navbar",
  data() {
    return {
      showMenu: false,
      faEnvelope, faEnvelopeOpen
    };
  },
  props: ["minNav", "textWhite"],
  created() {
    this.minNav;
  },
  methods: {
    ...mapMutations(["navbarMinimize"]),
    ...mapActions(["toggleSidebarColor"]),

    toggleSidebar() {
      this.toggleSidebarColor("bg-white");
      this.navbarMinimize();
    },
    logout(){
      localStorage.removeItem('authToken');
      axiosService.updateToken();
      this.$store.commit('setUser', {});
      this.$router.push({'name': 'Sign In'});
    },
    formatDate(inputDate) {
      const date = this.$moment(inputDate);
      const now = this.$moment();

      if (now.diff(date, 'days') <= 7) {
          return date.fromNow(); 
      }
      return date.format('L'); 
    },
    async markRead(notif) {
      if(!notif.is_read) {
        await userService.markReadNotification(notif.id);
        this.$store.dispatch('fetchNotifications');
      }
    }
  },
  components: {
    Breadcrumbs,
    FontAwesomeIcon,
  },
  computed: {
    ...mapGetters(['getBreadcrumbs']),
    breadcrumbs() {
      return this.getBreadcrumbs;
    },
    role(){
      return userService.getRoleNameById(this.$store.state.user?.role_id)
    },
  },
  updated() {
    const navbar = document.getElementById("navbarBlur");
    window.addEventListener("scroll", () => {
      if (window.scrollY > 10 && this.$store.state.isNavFixed) {
        navbar.classList.add("blur");
        navbar.classList.add("position-sticky");
        navbar.classList.add("shadow-blur");
      } else {
        navbar.classList.remove("blur");
        navbar.classList.remove("position-sticky");
        navbar.classList.remove("shadow-blur");
      }
    });
  },
};
</script>

<style scoped>
.notif-section{
  display: flex;
  align-items: center;
}
.notif-badge {
  background: red;
  color: white;
  padding: 3px;
  margin-left: 4px;
  border-radius: 50px;
  font-size: 13px;
  width: 25px;
  height: 25px;
  text-align: center;
  font-weight: bold;
}
</style>
